export default "/assets/images/sneezing-face.png?9c4e3ca35608af8ec00ef3821688b247";